import classnames from 'classnames';
import React from 'react';

import { PageFooterContainer } from '../page-footer';
import styles from './page-footer.less';

interface Props {
    container: PageFooterContainer;
}

export const PageFooter: React.SFC<Props> = ({ container }) => (
    <div className={classnames('page-footer', styles.pageFooter)}>
        <img
            src="/assets/images/powered-by-st-copy-2.png"
            alt="ServiceTitan"
            srcSet="/assets/images/powered-by-st-copy-2.png 1x,
                /assets/images/powered-by-st-copy-2@2x.png 2x,
                /assets/images/powered-by-st-copy-2@3x.png 3x"
        />
        {container.showContactUs ? (
            <a className="gray-text" onClick={container.handleContactUs}>
                Contact Us
            </a>
        ) : null}
    </div>
);
